import React from "react";
import HeatingAssistant from "./HeatingAssistant";

function App() {
  return (
    <div className="min-h-screen bg-slate-100 py-8">
      <HeatingAssistant />
    </div>
  );
}

export default App;
